<template>
	<div class=" investmentClues" >
	<leftnav class="fl" mkcode="C" itemcode="C-YSZSXS"></leftnav> 
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<!-- 头部盒子开始 -->
				<div class="whitebox right_topbox">
					<div class="right_boxtitle"> 
						<span class="fl right_title">{{curWebsite.keyword}}{{curWebsite.type == 2 ?'':'线索'}}</span>
				   <cluetips></cluetips>
							<video-teaching :type="3" seat="top"></video-teaching> 
						</div>
						<!-- 筛选项开始 -->
				<div class="opport-screen-list1">
				<div class="spage-searchbox ">
					<ClueNav tabCode="yszs"></ClueNav> 
					<dl class="opport-screen bdbe" >
						<dt class="fl">城市</dt>
						<dd class="fl">
							<span :class="liancity == 0?'a-screen current':'a-screen'"  @click="liancity=0;getclue()">本市</span>
						<span :class="liancity == item.cityId?'a-screen current':'a-screen'" @click="liancity=item.cityId;getclue()" :key="i" v-for="(item,i) in lianctiy">{{item.cityName}}</span> 
						</dd>
					</dl>
				<!-- 	<dl class="opport-screen bdbe" >
						<dt class="fl">企业类别</dt>
						<dd class="fl">
						<span :class="cstype == 1?'a-screen current':'a-screen'" @click="cstype=1;getclue()">供应商</span>
						<span :class="cstype == 2?'a-screen current':'a-screen'" @click="cstype=2;getclue()">客户</span> 
						</dd>
					</dl> -->
				</div> 
			</div>
			<!-- 筛选项结束 -->
			</div>
			<!-- 头部盒子结束 -->  
			<!-- 表格内容开始 -->
			<div class="whitebox"   >
				<div class="enterparise_guide oh" style="width: 95%; ">
					<p class="fl">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
				</div>
					 
	<!-- 供应链招商 -->	
			<div class="enterprise_list_box" > 
			<table border="0" cellspacing="0" cellpadding="0"  class="yszsTable w95mg enterprise_table">
				<tr><th>本地重点企业</th><th>供应商</th><th>客户</th></tr>
				<tr :key="i" v-for="(list,i) in enterprise_list" v-if="i<tableListNum">
					<td class="titletd"><span class="title fwb" @click="routerlinkid('/enterprises',list.stockCode,list.title)">{{list.title}}</span></td>
					<td class="">
						<span :key="index" v-for="(item,index) in list.supplier" :class="item.stockCode != '' ? 'curp yszs_span bdre':'yszs_span bdre'"  @click="routerlinkid('/enterprises',item.stockCode,'gk')" v-show="index<6">{{item.title}}</span>
					 <span class="yszs_span curp"></span>
					</td>
					<td>
						<span :key="index" v-for="(item,index) in list.customer" :class="item.stockCode != '' ? 'curp yszs_span':'yszs_span'"  @click="routerlinkid('/enterprises',item.stockCode,'gk')" v-show="index<6">{{item.title}}</span> 
					 <span class="yszs_span curp tal"  @click="routerlinkid('/enterprises',list.stockCode,list.title)">更多信息>></span> 
						</td>
				</tr>
			</table>
			<freeUserTips :type="1" :bgtype="15" v-if="enterprise_list.length>2 && userdata.isFree"></freeUserTips>
			</div> 
			<!-- 表格内容结束 -->
			<div class="centerpage1 company_pagelist" v-show="totalPage>1">
				<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
					v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
				</zpagenav>
			</div> 
			</div> 
			</div>
		</div>
	</div>
	</template>
	
	<script>
		import { dataInJs } from "../../utils/city.js";
		import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
		import { mapState, mapMutations, mapGetters } from "vuex";
	
		export default {
		  name: 'investmentClues',
		  computed: {
			...mapState({
				isCollapse: (state) => state.isCollapse,
			}),
			...mapGetters(['isCollapse'])
		},
				data(){return{ 
					tableListNum:1,
					title:"以商招商",
					notionslide:false,//分类导航
					notionslide1:false,//城市选择
					notionslide3:false,//城市地图
					showmorecitydata:false,//显示更多城市选择
					notioneditbtn:true,//是否修改notion
					notioncodebtn:true,//第一次获取用户选择概念列表id
					citymapdata:[],//城市地图数据
					cityflag:false,//显示城市地图
					usernotionid:10,//用户选择id
					selectcitydata:[],//城市选择数据
					notionlist:[],//用户初始概念数据 
					notioncodelist:[],//用户初始概念数据id  
					usernotionlistsave:[],//用户选择的概念列表存储
					usernotionlist:[],//用户选择的概念列表
					total1:0,
					userdata:{},curWebsite:this.$api.getWebsiteType(), 
					// searchtype:2,//线索类型 2以商招商 1本省投资概率 3关键融资 4优质企业 
					pro:11,
					companytype:1, //1上市 2非上市公司
					node:1,
					pro4:0,
					liancity:0, //产业链线索城市
					city4:1,
					industryid:0,
					frequency:1, //融资频次
					enterprise_list:[],
					recommendLevel:3,
					strcolors:['#3A66BE', '#3A66BE', '#3A66BE'],
					provincedata:[],
					countydata:[],
					citydata:[],
					provinceid:0,
					cityid:0, 
					countyid:0,
					industryoptions1:[],
					lianctiy:[],
					cstype:1, //1供应商 2客户
					supplierlist:[],//供应商列表
					customerlist:[],//客户列表
					ipolist:[],//上市公司列表 
					page: 1,  //显示的是哪一页
					haspage:true,//是否还有下一页
					pageSize: 10, //每一页显示的数据条数
					total: 0, //记录总数 
					totalPage:1,
					maxPage:10,  //最大页数
					sort:5, //上市公司招商线索 排序 1营业收入 2营业增速 3净利润 4净利增速 5投资意愿
					notionguide:[{name:'先进制造业',children:[]},{name:'传统制造业',children:[]},{name:'未来产业',children:[]},],
					areadata:dataInJs(), //省份城市数据 
				}},
				created() { 
					this.$nextTick(() => {
							// 禁用右键
							document.oncontextmenu = new Function("event.returnValue=false");
							// 禁用选择
							document.onselectstart = new Function("event.returnValue=false");
						  });
				 var _this=this; 
					this.userdata =this.getuseriformation();
				
					//获取省份城市列表
					// this.$axios.get(this.$api.cyl.area.get(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
					// 	// console.log('省份城市列表'，res.data)
					// 	if(res.data.success){   
					// 	 _this.provincedata=res.data.list; 
					// 		_this.getindustry();
					// 	}else{ 
					// 		
					// 	} 
					// }).catch(function (error) { 
					// 	// 请求失败处理 console.log(error);
					// }); 
					_this.provincedata=this.areadata;
					// _this.getindustry();
					this.$axios.get(this.$api.cyl.notion.list()+'?level=4',{headers:{AuthToken:this.userdata.token}}).then(function(res){
						if(res.data.success){    
							var ddds=[]; 
							// console.log(res.data)
							_this.notionlist=res.data.list == null ? []:res.data.list;     
							_this.cityflag=true;
						}else{ 
							
						} 
					}); 
				},
				components: {
				 freeUserTips
				}, 
				mounted() { 
					document.getElementById('app').style.background = "#f0f3f5";
					this.pro = this.userdata.province;
					this.notionclickfun([{name:'',id:''}]);
					this.getclue(); 
					
					// this.getareaclue(this.pro);
				},
				methods: { 
					 //导航栏筛选
					 notionclickfun(arry){
						 this.usernotionlist=arry;
						 this.usernotionlistsave=arry; 
						 this.usernotionid=arry[0].id;
						 this.notioneditbtn=true;
						 // console.log('arr',arry);
						 this.getclue();
					 },
						chartmapclick:function(data){
							var type="";
							if(data.data!=undefined && data.data.length>0){ 
								type=1;
							};
							this.choosecityid(data.id,type);
							// this.notionslide3=false; 
						}, 
						choosecityide(art){
							// console.log(art);
							this.choosecityid(art[0],art[1]);
						},
					//省份城市选择
					 provincechoose(id,i){ 
							this.provinceid =id;this.cityid =0; this.countyid =0;
							this.countydata=[];
							if(i!="all" && this.provincedata[i].children != null){
									this.citydata=this.provincedata[i].children;
							}else{
								this.citydata=[];
							} 
							this.page=1; 
							// this.ajaxsearchcompany();
						},
					choosecity(id,i){
						//	console.log('choosecity',id);
						this.cityid =id;this.countyid =0;
						if(i!="all" && this.citydata[i].children!= null){
								this.countydata=this.citydata[i].children;
						}else{
							this.countydata=[];
						} 
						this.page=1; 
						// this.ajaxsearchcompany(); 
					}, 
					choosecounty(id){
						//	console.log('choosecity',id);
						this.countyid =id;
						this.page=1; 
						// this.ajaxsearchcompany();
					}, 
					//获取行业分类
					getindustry(){  
							var _this=this;  
							this.$axios.get(this.$api.cyl.parameter.stockindustry(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
								// console.log("行业分类",res);
								if(res.data.success){   
									_this.industryoptions1=res.data.list; 
								}
								else{ 
										
								} 
							}).catch(function (error) {
								// 请求失败处理 console.log(error);
							});  
							},
							detailrouterto(path,id,title){
								// console.log(title);
								if(id == 0 || id == ""){return;}
								let routeUrl = this.$router.resolve({
										path: path,query: {id:id,ctitle:title},
								});
								window.open(routeUrl.href, '_blank');  
							},  
							notionlistnumber(namelist,codelist){
								// console.log(namelist,codelist); 
								for(var i=0;i<namelist.length;i++){ 
								 let arry2=namelist[i].children;
									for(var d=0;d<namelist[i].children.length;d++){ 
										for(var s=0;s<codelist.length;s++){
											if(namelist[i].children[d].value  == codelist[s].code){
												namelist[i].children[d].count=codelist[s].count;
											}
										} 
										//二级
										// console.log('q',namelist[i].children[d].label);
										if(namelist[i].children[d].children!=null){
											for(var f=0;f<namelist[i].children[d].children.length;f++){
												for(var s=0;s<codelist.length;s++){
													if(namelist[i].children[d].children[f].value  == codelist[s].code){
														namelist[i].children[d].children[f].count=codelist[s].count;
													}
												}
												// console.log('f',namelist[i].children[d].children[f].label);
												if(namelist[i].children[d].children[f].children!=null){
														for(var g=0;g<namelist[i].children[d].children[f].children.length;g++){
															for(var s=0;s<codelist.length;s++){
																if(namelist[i].children[d].children[f].children[g].value  == codelist[s].code){
																	namelist[i].children[d].children[f].children[g].count=codelist[s].count;
																}
															}
															// console.log('g',namelist[i].children[d].children[f].children[g].label); 
															//
														}  
												} 
												//
											}  
										}  
									 //
									} 
								};  
								this.notionlist=namelist;
							}, 
							//获取产业链/区域/融资企业招商线索
							getclue(pages){
								var _this=this,ajaxurl='';
								_this.bus.$emit('loading', true);
								var ajpage=1;
								if(pages){
									ajpage=pages;
								}
								this.page=ajpage;
							 
									if(this.liancity ==0){
										var lianctiycode = this.userdata.city;
									}else{
										var lianctiycode = this.liancity;
									}
									var ajaxurl=this.$api.cyl.investclue.business()+'?city='+lianctiycode+'&page='+ajpage; 
									// var ajaxurl=this.$api.cyl.investclue.business()+'?city=31&page='+ajpage; 
									 // ajaxurl=this.$api.cyl.investclue.business()+'?city=4404 '; //产业链招商线索本地测试city=3503才有数据供应商 4404有客户
								 
									this.$axios.get(ajaxurl,{headers:{AuthToken:this.userdata.token}}).then(function(res){ 
										// console.log(_this.searchtype,"招商",res,ajaxurl);
										if(res.data.success){ 
													_this.lianctiy = res.data.cityList; 
												_this.enterprise_list = res.data.list;  
												for(var i=0;i<_this.enterprise_list.length;i++){
													if(_this.enterprise_list[i].customer.length>0 && _this.enterprise_list[i].customer.length>_this.enterprise_list[i].supplier.length){
														// _this.enterprise_list[i].customer.push({title:'更多信息>>',stockCode:_this.enterprise_list[i].stockCode});
													}
													if(_this.enterprise_list[i].supplier.length>0 && _this.enterprise_list[i].supplier.length>_this.enterprise_list[i].customer.length){
														// _this.enterprise_list[i].supplier.push({title:'更多信息>>',stockCode:_this.enterprise_list[i].stockCode});
													}else if( _this.enterprise_list[i].supplier.length==_this.enterprise_list[i].customer.length){
														// _this.enterprise_list[i].customer.push({title:'更多信息>>',stockCode:_this.enterprise_list[i].stockCode});
													} 
														if(_this.enterprise_list[i].customer.length>_this.enterprise_list[i].supplier.length){
														var len =	_this.enterprise_list[i].customer.length - _this.enterprise_list[i].supplier.length;
														// console.log(len);
														for(var n=0;n<len;n++){
															_this.enterprise_list[i].supplier.push({title:'',stockCode:''});
															// console.log(_this.enterprise_list[n]);
														} 
														} 
														else{
															var len2 =	_this.enterprise_list[i].supplier.length - _this.enterprise_list[i].customer.length;
															for(var a=0;a<len2;a++){
																_this.enterprise_list[i].customer.push({title:'',stockCode:''});
															} 
															// _this.enterprise_list[i].supplier.push({title:'更多信息>>',stockCode:_this.enterprise_list[i].stockCode});
														}  
												} 
											_this.tableListNum=_this.userdata.isFree ? 3 : 	_this.enterprise_list.length;
											_this.bus.$emit('loading', false);
											_this.totalPage=res.data.totalPage;
											_this.pageSize=res.data.pageSize;  
											_this.total=res.data.totalRecord; 
										}
										else{ 
												
										} 
									}).catch(function (error) {
										// 请求失败处理 console.log(error);
									});  
									},
					 
					pageHandler: function(page) { 
						if(this.userdata.isFree && page>1){
							this.$message({type:'warning',message:"本账号试用期已截止,如需延期请即刻与我们联系"});
							return;
						}
						this.page = page; 
						this.getclue(page);  
					},
					jsondouhao(name,data){
						if(data.length>0){ 
							var notionja="";
							if(data.length!=0){
								var douhao='%2C';
								for(var i=0;i<data.length;i++){ 
									if(i==data.length-1){
										douhao='';
									}
									notionja+=data[i].id+douhao;
								}
								notionja='&'+name+'='+notionja;
								return notionja;
							} 
						}else{
							return "";
						}
					},
				},
		}
	</script>
	
	<style> 
	/* 提示框箭头 */
	.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
	  border-top-color: #E0E8F9;
	}
	.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
	  border-top-color: #E0E8F9;
	} 
	/* 提示框背景色 */
	.atooltip {
	  background: #E0E8F9 !important; 
	}
	 
	</style>
	